<h5 class="zint-card-title max-width-85">{{ label }}</h5>
@if(!hasValue) {
<div class="aira-nodata-icon-backdrop">
    <i class="fa-duotone fa-thin fa-gauge-simple-high"></i>
    <p>No insights have been derived.</p>
</div>
}
@else {    
    <gauge [gaugeData]="gaugeInput" [ngClass]="{'blur-content-strong': previewOnly}"></gauge>
}
